var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvnetSilica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.72 41.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#52ba64;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avnet_silica_spot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235.72,21.44c-1-2-2.34-2.85-3.86-2.85a2.68,2.68,0,0,0-2.71,2.82c0,5.12,11.12,4.11,11.12,12.12,0,4.75-3.45,7.9-8.12,7.9s-7.64-3.08-8.56-7.23l3.34-2.11c.74,2.89,2.26,5.49,5.23,5.49a3.76,3.76,0,0,0,4-3.89c0-5.08-11-4-11-12a6.68,6.68,0,0,1,6.78-6.82A7.85,7.85,0,0,1,239,19.25Z",
    transform: "translate(-2 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.13,15.17h4.08V41.12h-4.08Z",
    transform: "translate(-2 -2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.92,15.17V37.27h11.2v3.86H256.85V15.17Z",
    transform: "translate(-2 -2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.57,15.17h4.08V41.12h-4.08Z",
    transform: "translate(-2 -2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.41,23.7c-1.3-3.3-3.11-5-6.64-5-4.37,0-7.86,3.08-7.86,9.42s3.48,9.42,7.86,9.42c3.52,0,5.34-1.67,6.64-5l3.86,1c-1.33,4.89-5,7.86-10.49,7.86-6.26,0-12-4.49-12-13.27s5.75-13.27,12-13.27c5.52,0,9.16,3,10.49,7.86Z",
    transform: "translate(-2 -2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.72,15.17l9,25.95h-4.15l-2.15-6.45h-9.27L317,41.12h-4.15l9-25.95Zm-5.34,15.64h6.82l-3.41-10.49Z",
    transform: "translate(-2 -2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.49 36.56 13.63 36.56 12.05 41.43 30.07 41.43 28.49 36.56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "22.32 0 29.45 0 42.12 39 34.99 39 22.32 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "19.8 0 12.67 0 0 39 7.13 39 19.8 0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 0 179.21 0 179.21 5.72 189.77 5.72 189.77 39 196.21 39 196.21 5.72 206.76 5.72 206.76 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "140.66 0 140.66 39 165.7 39 165.7 33.27 147.1 33.27 147.1 22.18 163.04 22.18 163.04 16.46 147.1 16.46 147.1 5.72 165.7 5.72 165.7 0 140.66 0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "73.78 0 64.67 29.14 55.55 0.01 55.55 0 48.42 0 61.09 39 68.24 39 80.91 0 73.78 0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "99.78 0 94.29 0 94.29 39 100.72 39 100.72 12.92 118.31 39 123.8 39 123.8 0 117.36 0 117.36 26.07 99.78 0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_10",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_11",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.16,7.72A2.86,2.86,0,1,1,218,4.86,2.86,2.86,0,0,1,215.16,7.72Zm0-5.19a2.29,2.29,0,0,0-2.29,2.33,2.29,2.29,0,1,0,4.57,0A2.28,2.28,0,0,0,215.16,2.53Zm.6,3.87-.63-1.22h-.4V6.4h-.57V3.31h1.16a1,1,0,0,1,1,.95.86.86,0,0,1-.61.84l.69,1.3Zm-.51-2.61h-.52v.93h.52a.47.47,0,1,0,0-.93Z",
    transform: "translate(-2 -2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvnetSilica);
export default __webpack_public_path__ + "static/media/Avnet_silica.5a7de35991eda34267bc48a91bbfbe80.svg";
export { ForwardRef as ReactComponent };